/**
 * ui/ServerPicker — saisie/sélection des serveurs TicketFlow (persistés en ORM/SQLite
 * local, via IPC). @author Dr Hamid MADANI <drmdh@msn.com>
 *
 * Seule config locale de l'admin : à quel serveur se connecter. Le serveur choisi
 * devient le `baseUrl` de l'API (via `onChange` → l'app hôte reconstruit le client).
 */
import React, { useCallback, useEffect, useState } from 'react';
import { listServers, addServer, removeServer, setActiveServer, hasServerStore } from '../ticketflow/servers';

export default function ServerPicker({ onChange }) {
  const available = hasServerStore();
  const [servers, setServers] = useState([]);
  const [name, setName] = useState('');
  const [url, setUrl] = useState('');
  const [busy, setBusy] = useState(false);

  const reload = useCallback(async () => {
    setServers(await listServers());
  }, []);
  useEffect(() => { reload(); }, [reload]);

  const notify = async () => { await reload(); if (onChange) onChange(); };
  const add = async (e) => {
    e.preventDefault();
    if (!url.trim() || busy) return;
    setBusy(true);
    try { await addServer({ name, url }); setName(''); setUrl(''); await notify(); }
    finally { setBusy(false); }
  };
  const select = async (id) => { await setActiveServer(id); await notify(); };
  const remove = async (id) => { await removeServer(id); await notify(); };

  if (!available) {
    return (
      <div className="server-picker">
        <label>Serveur TicketFlow</label>
        <p className="muted">La gestion des serveurs se fait dans l'application Windows (TicketFlow-admin).</p>
      </div>
    );
  }

  return (
    <div className="server-picker">
      <label>Serveur TicketFlow</label>

      {servers.length > 0 ? (
        <div className="server-list">
          {servers.map((s) => (
            <div key={s.id} className={s.active ? 'server-item active' : 'server-item'}>
              <button type="button" className="server-select" onClick={() => select(s.id)} title={s.url}>
                <b>{s.name}</b>
                <span className="muted">{s.url}</span>
              </button>
              <button type="button" className="server-remove" onClick={() => remove(s.id)} title="Retirer ce serveur">×</button>
            </div>
          ))}
        </div>
      ) : (
        <p className="muted">Aucun serveur enregistré — ajoutez-en un ci-dessous.</p>
      )}

      <form className="server-add" onSubmit={add}>
        <input placeholder="Nom (optionnel)" value={name} onChange={(e) => setName(e.target.value)} />
        <input placeholder="http://192.168.1.12:5000" value={url} onChange={(e) => setUrl(e.target.value)} />
        <button type="submit" disabled={busy || !url.trim()}>+ Ajouter</button>
      </form>
    </div>
  );
}
